// call your functions on doc ready!
$(document).ready(function(){
	mobileDrop();
	navScroll();
	desktopDropSub();
	mobileWholeSaleClick();
	tabScrollClick();
	okConsoleStamp();
	animateArrowIcon();
	popup();
    checkShareLoveForCheckout();
    saveVisitedProductData();
});


function saveVisitedProductData() {
   if ($('.product')[0]) {
       var url = window.location.href;
       
       // Remove the query string if it exists
       var indexOfQuery = url.indexOf('?');
       if (indexOfQuery !== -1) {
           url = url.substring(0, indexOfQuery);
       }

       var parts = url.split('/');
       var product_name = parts[parts.length - 1];
       
       // Remove any trailing slashes
       product_name = product_name.replace(/\/+$/, '');

       var related_products = [];

       if (localStorage.getItem('recommended-products')) {
           related_products = JSON.parse(localStorage.getItem('recommended-products'));
       }

       if (related_products.indexOf(product_name) === -1) {
           related_products.push(product_name);
           localStorage.setItem("recommended-products", JSON.stringify(related_products));
       }
   }
}




function checkShareLoveForCheckout(){
  var button = $('.product-wrap .Share-the-love #add-to-cart');
  button.click(function(){
     $.ajax({
            type: 'GET',
            url: '/cart.js',
            cache: false,
            dataType: 'json',
            success: function(cart) {
            
              if(cart.item_count == 0){
                 $('.alert-bot').addClass('hide');
              }
          }
          });
  });
}

function mobileDrop(){
	var burger = $('button.hamburger')
	var mobile_drop = $('ul.menu')
	burger.click(function(){
		$(this).toggleClass('is-active');
		mobile_drop.toggleClass('is-active');
	})
}

document.addEventListener('DOMContentLoaded', () => {
const hamburger = document.querySelector('.hamburger');
const header = document.querySelector('.header');

hamburger.addEventListener('click', () => {
  header.classList.toggle('active');
});
});

function navScroll(){
	var $document = $(document),
    $element = $('.header'),
    className = 'header-active';

    $document.scroll(function() {
	  if ($document.scrollTop() >= 10) {
	    // user scrolled 50 pixels or more;
	    // do stuff
	    $element.addClass(className);
	  } else {
	    $element.removeClass(className);
	  }
	});
}

function okConsoleStamp(){
	console.log('%c Website built by okmg.com ','background: #DDC5DF; color: #222; font-weight: bold; text-transform: uppercase;padding:2.5px 10px;border-radius:5px;');
}

function desktopDropSub(){
	var list_mob = $('.header .row.row-3 ul li a')
	var list_desk = $('.header .row.row-3 ul li')
	var sub = $('.header .row.row-3 ul li .sub-menu')

	// list.mouseenter(function(){
	// 	$(this).find('.sub-menu').addClass('sub-active');
	// });

	if ($(window).width() < 1100){
		//disable parent link on tablet and below
		$(".header .row.row-3 ul li:has(.sub-menu)").hover(function () {
			$(this).children("a").click(function () {
				return false;
			});
			list_mob.click(function(e){
				$('.sub-menu').removeClass('sub-active');
				$(this).parent().find('.sub-menu').toggleClass('sub-active');
			});
		});
		
	

	} else {
		list_desk.mouseenter(function(){

			$(this).find('.sub-menu').addClass('sub-active');
		});
	
		list_desk.mouseleave(function(){
			$(this).find('.sub-menu').removeClass('sub-active');
		})
	}
}

function mobileWholeSaleClick(){
	var location = $('.location-info-wrapper');
	var scrollTo = $('div#map');
	location.click(function(){
     $('html, body').animate({
	        scrollTop: scrollTo.offset().top - 20 
	    }, 'slow');
	});
}
function tabScrollClick(){
	var location = $('.brew-tab-content-wrapper');
	var scrollTo = $('div#tab-wrapper');
	if($("a").attr('href') == '#tab-wrapper'){
		$("a").attr('href','#tab-wrapper').click(function(){
			 $('html, body').animate({
						scrollTop: scrollTo.offset().top - 20 
				}, 'slow');
				return false;
		});
	}
}

function animateArrowIcon(){
	var arrow = $('.fa fa-angle-down.icon');

	arrow.click(function(){
		$(this).toggleClass('active');
	})
}

function popup(){
	var popup = $('.popup-wrapper');
	popup.addClass('active');

	var close = $('.popup-wrap .close-btn');
	console.log('clicked');
	close.click(function(){
		$('.popup-wrapper').addClass('hide');
	})
}

$(document).ready(function(){
  var subtotal_headercart = $("#headercartprice").val().replace('$','').replace(',','');
  if(subtotal_headercart == 0.00){
    $("#progressbarsection .ProBarHeader").hide();
    $("#progressbarsection .ProTextHeader").hide();
  }
  $(".ProBarHeader progress").val(subtotal_headercart*100);
  if(7500 > (subtotal_headercart*100)){
    $("#progressbar-text-header").html("You're only <b>$"+((7500/100) - subtotal_headercart)+"</b> away from free shipping."+'<a href="https://dimattinacoffee.com.au/pages/shipping-returns-policy"></a>');    
  }else{
    $("#progressbar-text-header").html("You've got free shipping!"+'<a href="https://dimattinacoffee.com.au/pages/shipping-returns-policy">*</a>');    
  }
  
  var subtotal_cart = $(".subtotal h3.gamma em#subtotal-price").text().replace('$','').replace(',','');
  var progeress_max_val = $(".ProBar progress").attr("max")
  
  $(".ProBar progress").val(subtotal_cart*100);
  if(progeress_max_val > (subtotal_cart*100)){
    $("#progressbar-text").html("You're only <b>$"+((progeress_max_val/100) - subtotal_cart)+"</b> away from free shipping. "+'<a href="https://dimattinacoffee.com.au/pages/shipping-returns-policy">*</a>');    
  }else{
    $("#progressbar-text").html("You've got free shipping! "+'<a href="https://dimattinacoffee.com.au/pages/shipping-returns-policy">*</a>');    
  }

  $(".cart-table .product-item .cart-item-qty.td-sml .qty-wrap a").click(function(){
    setTimeout(function(){
      subtotal_cart = $(".subtotal h3.gamma em#subtotal-price").text().replace('$','').replace(',','');
        $(".ProBarHeader progress").val(subtotal_cart*100);
        $(".ProBar progress").val(subtotal_cart*100);
        if(progeress_max_val > (subtotal_cart*100)){
          $("#progressbar-text").html("You're only <b>$"+((progeress_max_val/100) - subtotal_cart)+"</b> away from free shipping.<a href='https://dimattinacoffee.com.au/pages/shipping-returns-policy'>*</a>");
          $("#progressbar-text-header").html("You're only <b>$"+((progeress_max_val/100) - subtotal_cart)+"</b> away from free shipping.<a href='https://dimattinacoffee.com.au/pages/shipping-returns-policy'>*</a>");
        }else{
          $("#progressbar-text").html("You've got free shipping"+'<a href="https://dimattinacoffee.com.au/pages/shipping-returns-policy">*</a>');
          $("#progressbar-text-header").html("You've got free shipping!"+'<a href="https://dimattinacoffee.com.au/pages/shipping-returns-policy">*</a>');
        }
    }, 1000);
		
	});
 $("#add-to-cart").click(function(){
     $("#progressbarsection .ProBarHeader").show();
    $("#progressbarsection .ProTextHeader").show();
       setTimeout(function(){
          $.ajax({
            type: 'GET',
            url: '/cart.js',
            cache: false,
            dataType: 'json',
            success: function(cart) {
            var cart_subtotal_data =cart.items_subtotal_price;
            $(".ProBarHeader progress").val(cart_subtotal_data);
            if(7500 > (cart_subtotal_data)){
            $("#progressbar-text-header").html("You're only <b>$"+((7500/100) - cart_subtotal_data/100)+"</b> away from free shipping.<a href='https://dimattinacoffee.com.au/pages/shipping-returns-policy'>*</a>");    
            }else{
            $("#progressbar-text-header").html("You've got free shipping!"+'<a href="https://dimattinacoffee.com.au/pages/shipping-returns-policy">*</a>');    
            }
          }
          });

      }, 2000);
  }); 
   $('.gift-checkbox').click(function(){
    var elem = $(this);
    setTimeout(function(){
      if(elem.find('input').is(':checked')){
        $('.gift-card-recipient-fields').show();
      }
      else{
        $('.gift-card-recipient-fields').hide();
      }
    },400)
  })
});